/**
 * 行情单页固底导航更多弹框
 */
import React, { useState } from "react"
import { quotedata } from "../quotedata"
import "./index.less"
import { ShareStock } from "../share_stock"
import { StockLayer } from "../layer";

export function StockMoreNav(props: { quotedata: quotedata; onClose: Function }) {
  const [sharePanelVisible, setSharePanelVisible] = useState(false)

  const goAppStock = () => {
    let market = ""
    let code = ""
    if (props.quotedata.market == 0) {
      //深圳
      market = "sz"
    } else if (props.quotedata.market == 1) {
      market = "sh"
    }

    code = props.quotedata.code

    if (market) {
      location.href = "https://emwap.eastmoney.com/h52n?type=stock&code=" + code + "&market=" + market
    }
  }

  const clickShare = () => {
    setSharePanelVisible(true)
    // props.onClose()
  }

  const clickClose = () => {
    props.onClose()
  }

  return (
    <>
      <div className="stock-more-nav">
        <div>
          功能列表
          <i className="stock-more-close" onClick={clickClose}></i>
        </div>
        <ul>
          <li onClick={clickShare}>
            <i className="stock-more-share"></i>
            <p>分享</p>
          </li>
          <li onClick={goAppStock}>
            <i className="stock-more-remind"></i>
            <p>设置提醒</p>
          </li>
          <li onClick={goAppStock}>
            <i className="stock-more-diagnosis"></i>
            <p>智能诊股</p>
          </li>
          <li onClick={goAppStock}>
            <i className="stock-more-analysis"></i>
            <p>估值分析</p>
          </li>
          <li onClick={goAppStock}>
            <i className="stock-more-kxian"></i>
            <p>相似K线</p>
          </li>
        </ul>
      </div>
      {sharePanelVisible && <ShareStock quotedata={props.quotedata} onClose={() => setSharePanelVisible(false)} />}
      <StockLayer onClose={props.onClose}/>
    </>
  )
}
